module.exports = __webpack_public_path__ + "img/632.d1421a09.png";